<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading': dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '4' }}</span></div>
        <h4>Formula</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div>
            <div class="body-1 mb-8">Describe the formula for {{outcomeName}}. Click column headers to add variables.</div>
            <div #tableContainer class="table-container column-border table-big">
                <!-- Header row -->
                <div class="row header">
                    <div *ngFor="let col of columns" (click)="columnClicked(col)" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}" class="cell">
                        <div class="subtitle-2">{{col.name}}</div>
                        <span class="body-2">{{ displayRoughNum(col.uniqueValues) }}</span>
                    </div>
                </div>

                <!-- Data rows -->
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length">
                            {{col.someVals[0]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 1">
                            {{col.someVals[1]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 2">
                            {{col.someVals[2]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 3">
                            {{col.someVals[3]}}
                        </ng-container>
                    </div>
                </div>
                <div class="row">
                    <div *ngFor="let col of columns" class="cell" [ngClass]="{'inactive': !col.isEligible, 'selected': col.isSelected}">
                        <ng-container *ngIf="col.someVals && col.someVals.length > 4">
                            {{col.someVals[4]}}
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <label for="input_formula" class="d-flex body-1 mb-8">Edit the formula</label>
            <div [ngClass]="{'error': refineFormula}" class="input-block mb-8">
                <input class="text-field" [(ngModel)]="formula" (input)="formulaChanged()" id="input_formula" type="text">
                <span class="error-msg">Invalid formula</span>
            </div>
        </div>
        <div>
            <button (click)="save()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div class="info-block">
            <span class="body-1">Components</span>
            <span class="body-1 text-900">{{ componentsList }}</span>
        </div>
        <div>
            <button (click)="editClick()" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
